import {
    ActionButton, 
    // AddCartIcon,
    AddedCartButton,
    CounterDiv,
    Type,
} from 'src/common/organisms/setsanditems/SetsAndItems.styled';
import AddCartButton from '../../atomics/addCartButton/AddCartButton';
import AddCartIcon from '../../atomics/addCartButton/AddCartIcon';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import TissueItemIcon from 'src/assets/images/TissueItemIcon.svg';
import NonTissueItemIcon from 'src/assets/images/NonTissueItemIcon.svg';
import BatchLocationCard from 'src/pages/scheduleSurgery/components/shipping/BatchLocationCard';
import Checkbox from 'src/common/refactoredComponents/checkbox/Checkbox';
import { US_COUNTRY_CODE } from 'src/constants/appConstants';
import BOMChanges from 'src/assets/images/BOMChanges.svg';
import StorageRequest from 'src/assets/images/storage-request.svg';
import CheckMark from 'src/assets/images/CheckMark.svg';
import StepperAddBlue from 'src/assets/images/StepperAddBlue.svg';
import AlertCircleOutline from 'src/assets/images/AlertCircleOutline.svg';
import React, { useState, useRef } from 'react';
import { sizes } from 'src/styles/Media.styled';
import { KeyboardArrowDown } from '@material-ui/icons';
import { KeyboardArrowUp } from '@material-ui/icons';
import { Box, ClickAwayListener, Tooltip } from '@material-ui/core';
import { MoreHorizRounded } from '@material-ui/icons';
import styled from 'styled-components';
import BatchDropDown from 'src/common/components/batchDropDown';
import {
    Brands,
    BrandsName,
    CheckBoxContainer,
    Circle,
    Description,
    ItemListViewWrapper,
    ItemTable,
    ProductCfn,
    ProductContainer,
    ProductData,
    Quantity,
    TableData,
    TableHeader,
    TableHeaderContainer,
    TableRow,
    TypeText,
    InputBox,
    CheckMarkImg,
    id,
    NoMatchError
} from './index.styled';
import {
    getCurrencySymbol,
    isTransferSurgery,
    logErrorToConsole,
} from 'src/utils/util';
import { ITEMSDETAILS } from 'src/pages/equity/components/common/constants';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import DeleteIcon from 'src/assets/images/Menu/DeleteIcon.svg';
import warning from 'src/assets/images/warning.svg';
import {
    SelectedDiv,
    SelectedCurrentLoc,
    Parked,
} from 'src/pages/scheduleSurgery/components/shipping/NonTissueProductCard.styled';
import { setCurrencyFormatWithoutSymbol } from 'src/utils/util.js';
import NtCheckboxCheckedAndDisabled from '../../../pages/scheduleSurgery/components/shipping/NonTissuecomponents/NtCheckboxCheckedAndDisabled';
import NtCheckboxwithTransferFailedWithDropdown from '../../../pages/scheduleSurgery/components/shipping/NonTissuecomponents/NtCheckboxwithTransferFailedWithDropdown';
import NtCheckboxDropdownWithErroText from '../../../pages/scheduleSurgery/components/shipping/NonTissuecomponents/NtCheckboxDropdownWithErroText';
import {
    ProductErrorText,
    AlertIcon,
} from '../../../pages/scheduleSurgery/components/shipping/NonTissueProductCard.styled';
import { setItemLoader } from 'src/pages/equity/redux/actions';
import { Add } from '@material-ui/icons';
import { Remove } from '@material-ui/icons';
import {
    FONT_FAMILY_DEMI,
    X_SMALL_TEXT_PX,
    SEMANTIC_TEXT_SMALL_PX,
    SMALL_TEXT_PX,
    DARK_NAVY_FONT_COLOR,
    
} from 'src/styles/fonts/MCFontConstants';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

// Styled components defined outside the main component
const tooltipClasses = {
    tooltip: 'MuiTooltip-tooltip',
    arrow: 'MuiTooltip-arrow',
    popper: 'MuiTooltip-popper',
};

const HtmlTooltip = styled(
    ({ className, isTemplateScreen, isOrderScreen, ...props }) => (
        // <Tooltip {...props} classes={{ popper: className }} />
        <Tooltip
            {...props}
            classes={{ popper: className }}
            PopperProps={{
                ...props.PopperProps,
                style: { zIndex: 999999 },
            }}
            // {...props}
            // classes={{ popper: className }}
            // PopperProps={{
            //     ...props.PopperProps,
            //     ...((isTemplateScreen || isOrderScreen) && {
            //         style: {
            //             zIndex: 999999,
            //         },
            //     }),
            // }}
        />
    )
)(() => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: 'white',
    },

    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: 'white',
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: 220,
        fontSize: '12px',
        border: '1px solid #dadde9',
        padding: '10px',
        borderRadius: '2px',
        boxShadow: '0px 0px 6px #00000029',
    },
    [`& .${tooltipClasses.popper}`]: {
        zIndex: 999999,
    },
}));

const TooltipContent = styled(Box)`
    display: flex;
    align-items: center;
    flex-direction: row;
    cursor: ${({ cursor }) => cursor && cursor};
`;

const MoreIcon = styled(MoreHorizRounded)`
    width: 22px !important;
    height: 20px !important;
    color: #1010eb;
`;

const DownArrow = styled(KeyboardArrowDown)`
    width: 30px !important;
    height: 25px !important;
    color: #1010eb;
    margin-bottom: -7%;
    cursor: pointer;
`;

const UpArrow = styled(KeyboardArrowUp)`
    width: 30px !important;
    height: 25px !important;
    color: #1010eb;
    margin-bottom: -7%;
    cursor: pointer;
`;

const customPositionProps = (popperRef, anchorRef, clickPosition) => ({
    popperRef,
    anchorEl: {
        getBoundingClientRect: () => {
            const anchorRect = anchorRef.current?.getBoundingClientRect() || {
                top: 0,
                left: 0,
                width: 0,
                height: 0,
            };
            return new DOMRect(
                clickPosition?.x ?? anchorRect.left,
                anchorRect.top,
                0,
                anchorRect.height
            );
        },
    },
});

// Reusable Tooltip component

const TruncatedTooltip = ({
    text,
    maxLength,
    productCfn,
    isOrderScreen,
    isTemplateScreen,
    isBrand = false,
}) => {
    const [isOpen, setIsOpen] = React.useState(false);

    const [clickPosition, setClickPosition] = React.useState(null);
    const [isTruncated, setIsTruncated] = React.useState(false);
    const anchorRef = React.useRef(null);
    const popperRef = React.useRef(null);
    const textRef = React.useRef(null);

    const currentPopperProps = customPositionProps(
        popperRef,
        anchorRef,
        clickPosition
    );
    // : portalDisabledProps;

    const handleClick = (event) => {
        setClickPosition({ x: event.clientX });
        setIsOpen(!isOpen);

        // Update popper position after state changes
        if (popperRef.current) {
            setTimeout(() => {
                try {
                popperRef.current.update();
                } catch (error) {
                logErrorToConsole(error);
            }
            }, 0);
        }
    };

    const handleClose = () => {
        setIsOpen(false);
        setClickPosition(null);
    };

    // Check for truncation by comparing scrollWidth and clientWidth
    const checkTruncation = () => {
        if (textRef.current) {
            const isOverflowing =
                textRef.current.scrollWidth > textRef.current.clientWidth;
            setIsTruncated(isOverflowing);
        }
    };

    // useEffectWithErrorLogging to check truncation after rendering
    useEffectWithErrorLogging(() => {
        checkTruncation();
        window.addEventListener('resize', checkTruncation); // Re-check on resize

        // Cleanup
        return () => {
            window.removeEventListener('resize', checkTruncation);
        };
    }, [text, maxLength]); // Dependency on text and maxLength

    return (
        <ClickAwayListener onClickAway={handleClose}>
            <Box style={{ width: isBrand ? '94%' : '97%' }}>
                <HtmlTooltip
                    open={isOpen}
                    onClose={handleClose}
                    placement="top"
                    anchorEl={anchorRef.current}
                    PopperProps={currentPopperProps}
                    isTemplateScreen={isTemplateScreen}
                    isOrderScreen={isOrderScreen}
                    title={
                        <div>
                            <div
                                style={{
                                    fontWeight: '700',
                                    marginBottom: '3px',
                                }}
                            >
                                {!isBrand ? productCfn : null}
                            </div>
                            <div>{text}</div>
                        </div>
                    }
                    arrow
                >
                    <TooltipContent
                        ref={anchorRef}
                        id = 'tooltip-text'
                        onClick={isTruncated && handleClick}
                        cursor={isTruncated && 'pointer'}
                    >
                        <span
                            ref={textRef}
                            style={{ whiteSpace: 'nowrap', overflow: 'hidden' }}
                        >
                            {text}
                        </span>
                        {isTruncated && (
                            <Circle>
                                <MoreIcon />
                            </Circle>
                        )}
                    </TooltipContent>
                </HtmlTooltip>
            </Box>
        </ClickAwayListener>
    );
};

const TemplateCheckBox = ({
    item,
    checkBoxDetails,
    productWithIsPlaceHolderSet,
    isAddToBundle,
    isCondensedView,
    isTemplateScreen,
}) => {
    const [checkBoxInfo, setCheckBoxInfo] = useState({});
    useEffectWithErrorLogging(() => {
        setCheckBoxInfo({
            ...checkBoxDetails,
        });
        return () => {};
    }, [checkBoxDetails]);
    return (
        <CheckBoxContainer
            isAddToBundle={isAddToBundle}
            isCondensedView={isCondensedView}
            isTemplateScreen={isTemplateScreen}
        >
            <Checkbox
                name={checkBoxInfo.name}
                onCheckboxSelectionChange={() => {
                    try {
                        checkBoxInfo.checked = !checkBoxInfo.checked;
                        setCheckBoxInfo({ ...checkBoxInfo });
                        checkBoxDetails.onChange();
                    } catch (error) {
                        logErrorToConsole(error);
                    }
                }}
                checked={checkBoxInfo.checked}
                id={checkBoxInfo.id}
                disabled={productWithIsPlaceHolderSet?.some(
                    (data) => data.cfn === item.cfn
                )}
                background={'none'}
                checkboxBorder={'1.5px solid #555555'}
                alignItemDirection={'center'}
                hoverEffect={'false'}
                disableFocusEffect={'true'}
            />
        </CheckBoxContainer>
    );
};

const CheckBoxTransfer = ({
    item,
    inventoryShipping,
    countryISOCode,
    handleLocationChange = () => {},
    checked = false,
    selectedLocation,
    allocatedData,
    isShowCheckBox,
    isMessageDisplay,
    isShowLabelEmpty,
    isShowDropDown,
}) => {
    const { t } = useTranslation();
    let batchLocations = useSelector((state) =>
        state.shippingBatchAllocation.batchAllocations.find(
            (batch) => batch.productCfn === (item?.cfn || item?.productCFN)
        )
    );
    const selectedBatchLocationTemplate = (option, props) => {
        if (option) {
            return option.id === 'Batch Not Found' ? (
                <SelectedDiv width={item?.isReservationSet && '261px'}>
                    <SelectedCurrentLoc
                        width={'auto'}
                        // width={option.isParked ? '80%' : '100%'}
                        // mbWidth={option.isParked ? '60%' : '100%'}
                    >
                        {t(
                            'scheduleSurgery.Shipping.ProductCard.batchNotFound'
                        )}
                    </SelectedCurrentLoc>
                </SelectedDiv>
            ) : (
                <SelectedDiv width={item?.isReservationSet && '261px'}>
                    <SelectedCurrentLoc
                        width={'auto'}
                        // width={option.isParked ? '80%' : '100%'}
                        // mbWidth={option.isParked ? '60%' : '100%'}
                    >
                        {option.currentLocationFormatted}
                    </SelectedCurrentLoc>
                    {option.isParked && !item?.isReservationSet && (
                        <Parked>
                            {t('equity.common.setsAndItems.parked')}
                        </Parked>
                    )}
                </SelectedDiv>
            );
        }

        return <span>{props.placeholder}</span>;
    };

    const batchLocationTemplate = (option) => {
        return (
            <BatchLocationCard
                option={option}
                isReservationSet={item?.isReservationSet}
            />
        );
    };

    return (
        <>
            {item?.lineNumber != null || item?.lineNumber != undefined ? (
                item?.batchAllocation?.id && !inventoryShipping ? (
                    batchLocations?.batchAllocations
                        ?.filter((batch) =>
                            countryISOCode !== US_COUNTRY_CODE ? true : batch.isParked
                        )
                        .find(
                            (batch) => batch.id === item?.batchAllocation?.id
                        ) ? (
                        <NtCheckboxCheckedAndDisabled
                            label={t(
                                'scheduleSurgery.Shipping.ProductCard.TransferComplete'
                            )}
                            batchLocations={batchLocations}
                            productKey={item.productKey}
                            nonTissueProduct={item}
                            isShowCheckBox={isShowCheckBox}
                            isMessageDisplay={isMessageDisplay}
                            isShowLabelEmpty={isShowLabelEmpty}
                            isShowSetLocation={false}
                        />
                    ) : (
                        <NtCheckboxwithTransferFailedWithDropdown
                            checkBoxClick={() => {
                                try {
                                    if (!inventoryShipping)
                                        handleLocationChange(
                                            item.productKey,
                                            !item.shippingRequirement
                                        );
                                } catch (error) {
                                    logErrorToConsole(error);
                                }
                            }}
                            inventoryShipping={inventoryShipping}
                            AlertCircleOutline={AlertCircleOutline}
                            nonTissueProduct={item}
                            batchLocations={batchLocations}
                            selectedBatchLocationTemplate={
                                selectedBatchLocationTemplate
                            }
                            checked={checked}
                            batchLocationTemplate={batchLocationTemplate}
                            selectedLocation={selectedLocation}
                            handleLocationChange={handleLocationChange}
                            isShowCheckBox={isShowCheckBox}
                            isMessageDisplay={isMessageDisplay}
                            isShowLabelEmpty={isShowLabelEmpty}
                            isShowSetLocation={false}
                            isShowDropDown={isShowDropDown}
                        />
                    )
                ) : (
                    <NtCheckboxCheckedAndDisabled
                        label={t(
                            'scheduleSurgery.Shipping.ProductCard.TransferComplete'
                        )}
                        batchLocations={batchLocations}
                        productKey={item.productKey}
                        nonTissueProduct={item}
                        isShowCheckBox={isShowCheckBox}
                        isMessageDisplay={isMessageDisplay}
                        isShowLabelEmpty={isShowLabelEmpty}
                        isShowSetLocation={false}
                    />
                )
            ) : (
                <NtCheckboxDropdownWithErroText
                    isShowCheckBox={isShowCheckBox}
                    isMessageDisplay={isMessageDisplay}
                    isShowLabelEmpty={isShowLabelEmpty}
                    checked={checked}
                    checkBoxClick={() => {
                        try {
                            if (!inventoryShipping)
                                handleLocationChange(
                                    item.productKey,
                                    !item.shippingRequirement
                                );
                        } catch (error) {
                            logErrorToConsole(error);
                        }
                    }}
                    inventoryShipping={inventoryShipping}
                    batchLocations={batchLocations}
                    selectedBatchLocationTemplate={
                        selectedBatchLocationTemplate
                    }
                    allocatedData={allocatedData}
                    batchLocationTemplate={batchLocationTemplate}
                    selectedLocation={selectedLocation}
                    handleLocationChange={handleLocationChange}
                    nonTissueProduct={item}
                    isShowSetLocation={false}
                    isShowDropDown={isShowDropDown}
                />
            )}

            {/*end transfer surgery check*/}
        </>
    );
};

const AddIcon = styled(Add)`
    width: 19px;
    height: 19px;
    font-size: 14px !important;
    color: #1010eb !important;
`;
const RemoveIcon = styled(Remove)`
    width: 19px;
    height: 19px;
    color: #1010eb !important;
    font-size: 14px !important;
`;
const ListView = ({
    products,
    isOrderScreen = false,
    isForProductGuide = false,
    setProductToBeAdded = () => {},
    productValidation,
    handleSetItemClick = () => {},
    setsQuantityCheck = () => {},
    removeCount = () => {},
    addCount = () => {},
    deleteProduct = () => {},
    isShippingScreen = false,
    isReviewSubmitScreen = false,
    inventoryShipping = false,
    handleLocationChange = () => {},
    checkAll = false,
    checkSelectAllDisabled = () => {},
    selectAllDisabled = '',
    handleShipAllChange = () => {},
    isItem = false,
    selectedLocation,
    isTemplateScreen = false,
    handleCheckBoxSelection = () => {},
    moreTemplates = false,
    isEquityTemplate = false,
    isEquityPage = false,
    isReviewSubmitScreenEquity,
    onBomClick = () => {},
    showDontShip = true,
    isCartScreen = false,
    isFromTemplates = false,
    isSurgery = false,
    isBatchSelected = false,
    setIsBatchSelected = () => {},
    isSubItem = false,
    isBundleView = false,
    handleBundlePopup = () => {},
    handleBundleSetItemClick = () => {},
    isItemBundlePopup = false,
    isImplant,
    productKeyBundle = '',
    isTemplateDetail = false,
    parentIndex = '',
    isAddToBundle = false,
    updateProductQuantity = () => {},
    isQuickOrder,
    isForSetItem,
    isOnlyPlusButton,
    isConsignmentAdd,
    isEquity,
    handleAddToCartSynchronized,
    isFromIndependentProductGuide=false,
    isFromSetItemDetailsLists = false,
    marginBottom,
    isQuickOrderEquityTemplate = false,
    isScheduleSurgery
}) => { 
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const winWidth = window.innerWidth;
    const isMobileView = winWidth < sizes.smalDevice;
    const ipadAir = winWidth === sizes.ipadAir;
    const ipadMini = winWidth === sizes.smalDevice;
    const isTabletView =
        winWidth >= sizes.smalDevice && winWidth <= sizes.mediumDevice;
    const countryISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );

    useEffectWithErrorLogging(() => {
        const timer = setTimeout(() => {
            try {
            dispatch(setItemLoader(false));
            } catch (error) {
                logErrorToConsole(error);
            }
        }, 1500);

        return () => clearTimeout(timer);
    }, [products]);

    const isCondensedView = useSelector(
        (state) => state.loginReducer.isCondensedView
    );
    const shipDontShipSurgery = useSelector(
        (state) => state.loginReducer.shipDontShipSurgery
    );
    const productWithIsPlaceHolderSet = useSelector(
        (state) => state.surgeryDetailsReducer.productWithIsPlaceHolderSet
    );
    const isItemListView = useSelector(
        (state) => state.orderSummaryReducer.isItemListView
    );
    const orderType = useSelector(
        (state) => state.orderSummaryReducer?.orderBasicDetails?.currentOrderType
    );
    const currencyISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.currencyISOCode
    );

    const [allocatedData, setAllocatedData] = useState('');
    const [expandedItems, setExpandedItems] = useState({});
    const [, setQuantityValue] = useState(0);
    
    // Rate limiting for rapid clicks - prevent race conditions
    const lastClickTimeRef = useRef({});    
    const isClickAllowed = (itemKey) => {
        const now = performance.now(); // Use high precision timestamp instead of Date.now()
        const lastClickTime = lastClickTimeRef.current[itemKey] || 0;
        const timeDiff = now - lastClickTime;
        
        // Only block if the SAME item is clicked too rapidly (50ms for same item)
        if (timeDiff < 50) {  
            return false;
        }
        
        lastClickTimeRef.current[itemKey] = now; 
        return true;
    };
    
    // Cleanup effect to prevent memory leaks
    useEffectWithErrorLogging(() => {
        return () => {
            lastClickTimeRef.current = {};
        };
    }, []);

    // Rate limiting for rapid clicks - prevent race conditions
    // const lastClickTimeRef = useRef({});
    // const isClickAllowed = (itemKey) => {
    //     const now = performance.now(); // Use high precision timestamp instead of Date.now()
    //     const lastClickTime = lastClickTimeRef.current[itemKey] || 0;
    //     const timeDiff = now - lastClickTime;

    //     // Only block if the SAME item is clicked too rapidly (50ms for same item)
    //     if (timeDiff < 50) {
    //         console.log(
    //             'Click blocked by rate limiting for SAME item:',
    //             itemKey,
    //             'Time diff:',
    //             timeDiff.toFixed(2),
    //             'ms'
    //         );
    //         return false;
    //     }

    //     lastClickTimeRef.current[itemKey] = now;
    //     console.log(
    //         'Click allowed for item:',
    //         itemKey,
    //         'Timestamp:',
    //         now.toFixed(2)
    //     );
    //     return true;
    // };

    // Cleanup effect to prevent memory leaks
    useEffectWithErrorLogging(() => {
        return () => {
            lastClickTimeRef.current = {};
        };
    }, []);

    const validateQuantity = (value, productKeyBundle, itemProductKey) => {
        const limitTwoDigits = /^\d{0,2}$/;
        const valuedigits = value;
        const removeLeadingZeroValue = removeLeadingZeros(value);
        if (removeLeadingZeroValue > 50){
           setsQuantityCheck(true);
           return;
        }
        if (limitTwoDigits.test(valuedigits)) {
            updateProductQuantity(
                removeLeadingZeroValue,
                productKeyBundle ? productKeyBundle : itemProductKey,
                productKeyBundle ? itemProductKey : ''
            );
            setQuantityValue(removeLeadingZeroValue);
        }
    };

    // Toggle expansion for a specific item
    const toggleItem = (itemId) => {
        setExpandedItems((prev) => ({
            ...prev,
            [itemId]: !prev[itemId],
        }));
    };

    const getMaxLength = (type) => {
        if (type === 'description') {
            return isOrderScreen ? 47 : isTabletView ? 42 : 60;
        }
        if (type === 'brand') {
            return isOrderScreen ? 22 : 30;
        }
        return 0;
    };
    const { productBomDetails } = useSelector(
        (state) => state.checkProductBomReducer
    ); 
    const isTissueProduct =
        (products?.length > 0 && products[0]?.salesOrg === 'S030') ?? false;
    const [, setReservationBatch] = useState('');
    const isTablet = winWidth >= 768 && winWidth < 1024;
    const isIPadPro = winWidth >= 1024 && winWidth <= 1366;
    if (!products || products?.length === 0) {
        return null;
    }

    const removeLeadingZeros = (val) => {
        return String(val).replace(/^0+/, '') || '0';
    };

    const renderDesktopView = () => (
        <>
            <ItemTable borderBottom={isSubItem && 'none'} isQuickOrder={isQuickOrder}>
                <TableHeaderContainer
                    position={isForProductGuide && 'sticky'}
                    top={isForProductGuide && '0'}
                    zIndex={isForProductGuide && '1'}
                    height={isForProductGuide && '50px'}
                >
                    <tr>
                        <TableHeader
                        ipadPadding={'0px'}
                        ipadAirPadding={'0px'}
                            width={
                                isSurgery && isTablet
                                    ? countryISOCode === 'US'
                                        ? '17%'
                                        : '25%'
                                    : countryISOCode === 'US'
                                    ? isAddToBundle && isIPadPro
                                        ? '25%'
                                        : isFromTemplates
                                        ? '11%'
                                        : isTemplateScreen
                                        ? '11%'
                                        : '17%'
                                    : isSurgery
                                    ? '18%'
                                    : isEquityPage && isTablet
                                    ? '12%'
                                    : countryISOCode === 'JP' ? '25%'
                                    : '17%'
                            }
                            isSubItem={isSubItem}
                            paddingLeft={true}
                            fontSize={isForProductGuide && SMALL_TEXT_PX }
                            // style={{ paddingLeft: '19px' }}
                        >
                            {t(
                                'scheduleSurgery.surgery.notifications.itemListView.Product'
                            )}
                        </TableHeader>
                        {countryISOCode === 'US' &&
                            !isForProductGuide &&
                            !isForSetItem && (
                                <TableHeader
                                   width={isSubItem 
                                        ? '6.5%'
                                        : isTemplateScreen
                                        ? '7%'
                                        : '12%'}
                                    isSubItem={isSubItem}
                                    paddingLeft={true}
                                ></TableHeader>
                            )}
                        <TableHeader
                        isForSetItem = {isForSetItem}
                            isForProductGuide = {isForProductGuide}
                            isQuickOrder = {isQuickOrder}
                            isSubItem={isSubItem}
                            width={
                                isSurgery && isTablet
                                    ? '30%'
                                    : isSurgery
                                    ? '37%'
                                    : isShippingScreen
                                    ? '28%'
                                    : isReviewSubmitScreen
                                    ? '50%'
                                    : isReviewSubmitScreenEquity
                                    ? '30%'
                                    : isOrderScreen
                                    ? '37%'
                                    : isEquityPage
                                    ? isSubItem
                                        ? '31.5%'
                                        : '20%'
                                    : isBundleView && isTemplateScreen
                                    ? '36%'
                                    : isSubItem && isEquityTemplate
                                    ? '24%'
                                    : isSubItem && isTemplateDetail
                                    ? '36%'
                                    : '36%'
                            }
                            fontSize={isForProductGuide && SMALL_TEXT_PX }
                            ipadPaddingLeft={'10px !important'}
                            ipadAirPaddingLeft={'10px !important'}
                        >
                            {t(
                                'scheduleSurgery.surgery.notifications.itemListView.description'
                            )}
                        </TableHeader>
                        {(isReviewSubmitScreen ||
                            isReviewSubmitScreenEquity ||
                            isTemplateScreen ||
                            isOrderScreen) &&
                            !isBundleView && (
                                <TableHeader
                                    width={isTemplateScreen ? '15%' : '12%'}
                                    className="brand"
                                    isSubItem={isSubItem}
                                >
                                    {t(
                                        'scheduleSurgery.surgery.notifications.itemListView.brand'
                                    )}
                                </TableHeader>
                            )}
                        {(isOrderScreen ||
                            isReviewSubmitScreenEquity ||
                            isTemplateScreen) &&
                            isBundleView && (
                                <TableHeader
                                    width={
                                        isReviewSubmitScreenEquity
                                            ? '15%'
                                            : isBundleView
                                            ? '16%'
                                            : '16%'
                                    }
                                    className="brand"
                                    isSubItem={isSubItem}
                                >
                                    {t(
                                        'orders.orderDetails.orderDetailTab.extrasOrderDetail.Bundle.inBundle'
                                    )}
                                </TableHeader>
                            )}
                        {isOrderScreen &&
                            !isSubItem &&
                            !isItemListView &&
                            orderType !== 'KE' &&
                            orderType !== 'KB' && (
                                <TableHeader
                                    width={isOrderScreen ? '15%' : '16%'}
                                    className="brand"
                                    isSubItem={isSubItem}
                                >
                                    {t('common.tableView.statusLabel')}
                                </TableHeader>
                            )}
                        {(isTemplateScreen || isOrderScreen) && (
                            <>
                                <TableHeader
                                    width={
                                        isReviewSubmitScreenEquity
                                            ? '12%'
                                            : '15%'
                                    }
                                    className="quantityUoM"
                                    isSubItem={isSubItem}
                                    isTemplateScreen={isTemplateScreen && !isFromTemplates}
                                >
                                    {t('common.tableView.qtyUom')}
                                </TableHeader>
                                {!isOrderScreen && !isFromTemplates && (
                                    <TableHeader
                                        className="quantity"
                                        isSubItem={isSubItem}
                                        width={
                                            isAddToBundle &&
                                            isIPadPro &&
                                            isCondensedView
                                                ? '3%'
                                                : '15%'
                                        }
                                    ></TableHeader>
                                )}
                            </>
                        )}

                        {isShippingScreen ||
                        isReviewSubmitScreen ||
                        isReviewSubmitScreenEquity ? (
                            <>
                                <TableHeader
                                    width={
                                        isShippingScreen
                                            ? '15%'
                                            : isReviewSubmitScreenEquity
                                            ? '16%'
                                            : '16%'
                                    }
                                    className="quantityUoM"
                                    isSubItem={isSubItem}
                                >
                                    {t('common.tableView.quantityUom')}
                                </TableHeader>
                                {!isReviewSubmitScreen &&
                                    !isReviewSubmitScreenEquity &&
                                    showDontShip && (
                                        <TableHeader
                                            width={isShippingScreen && '15%'}
                                            className="quantity"
                                            isSubItem={isSubItem}
                                            padding={isShippingScreen && '7px 8px'}
                                        >
                                            {!isItem &&
                                                shipDontShipSurgery !==
                                                    'NOT_VISIBLE' && (
                                                    <Checkbox
                                                        checked={checkAll}
                                                        label={t(
                                                            'common.dontShip'
                                                        )}
                                                        onCheckboxSelectionChange={() => 
                                                            handleShipAllChange(
                                                                isImplant
                                                                    ? 'implant'
                                                                    : 'instrument'
                                                            )
                                                        }
                                                        disabled={
                                                            checkSelectAllDisabled(
                                                                products,
                                                                countryISOCode
                                                            ) ||
                                                            selectAllDisabled
                                                        }
                                                        id = 'dont-ship-all-checkbox'
                                                        margin={'0 6px 0 0'}
                                                        labelStyleObj={{
                                                            fontSize: X_SMALL_TEXT_PX,
                                                            fontFamily: FONT_FAMILY_DEMI,
                                                            color: DARK_NAVY_FONT_COLOR,
                                                            margin: '0px 0px 0px 3px',
                                                            fontWeight: '700'
                                                        }}
                                                        background={'none'}
                                                        checkboxBorder={'1.5px solid #555555'}
                                                        alignItemDirection={'center'}
                                                        hoverEffect={'false'}
                                                        disableFocusEffect={'true'}
                                                    />
                                                )}
                                        </TableHeader>
                                    )}
                                {!isReviewSubmitScreen &&
                                    !isReviewSubmitScreenEquity && (
                                        <TableHeader
                                            width={
                                                isShippingScreen
                                                    ? ipadMini
                                                        ? '20%'
                                                        : '28%'
                                                    : '18%'
                                            }
                                            className="batch"
                                            isSubItem={isSubItem}
                                        >
                                            {!isItem &&
                                                !isTissueProduct &&
                                                (shipDontShipSurgery !==
                                                    'NOT_VISIBLE' ||
                                                    products
                                                        ?.filter(
                                                            (item) =>
                                                                !item?.isTemplateEntryDeleted
                                                        )
                                                        .some(
                                                            (item) =>
                                                                item.isSet &&
                                                                item.isReservationSet
                                                        )) &&
                                                t('common.batchSelection')}
                                        </TableHeader>
                                    )}

                                {isReviewSubmitScreenEquity && !isSubItem && (
                                    <>
                                        {' '}
                                        <TableHeader
                                            className="uom"
                                            width={
                                                isReviewSubmitScreenEquity
                                                    ? '12%'
                                                    : '14%'
                                            }
                                            isSubItem={isSubItem}
                                        >
                                            {`${t(
                                                'common.tableView.unitPrice'
                                            )} ${getCurrencySymbol(
                                                currencyISOCode
                                            )}`}
                                        </TableHeader>
                                        <TableHeader
                                            className="uom"
                                            width={
                                                isReviewSubmitScreenEquity
                                                    ? '12%'
                                                    : '14%'
                                            }
                                            isSubItem={isSubItem}
                                        >
                                            {`${t(
                                                'common.tableView.extPrice'
                                            )} ${getCurrencySymbol(
                                                currencyISOCode
                                            )}`}
                                        </TableHeader>
                                    </>
                                )}
                            </>
                        ) : (
                            !isTemplateScreen &&
                            !isOrderScreen && (
                                <>
                                    {!isBundleView && (
                                        <TableHeader
                                            width={isEquityPage ? '12%' : '20%'}
                                            className="brand"
                                            isSubItem={isSubItem}
                                            fontSize={
                                                isForProductGuide && SMALL_TEXT_PX
                                            }
                                        >
                                            {t(
                                                'scheduleSurgery.surgery.notifications.itemListView.brand'
                                            )}
                                        </TableHeader>
                                    )}
                                    {isBundleView && (
                                        <TableHeader
                                            width={
                                                isEquityTemplate ? '20%' : '16%'
                                            }
                                            className="brand"
                                            isSubItem={isSubItem}
                                        >
                                            {t(
                                                'orders.orderDetails.orderDetailTab.extrasOrderDetail.Bundle.inBundle'
                                            )}
                                        </TableHeader>
                                    )}
                                    {!isForProductGuide && !isForSetItem && (
                                        <TableHeader
                                            className="quantity"
                                            isSubItem={isSubItem}
                                            width={
                                                isEquityPage
                                                    ? '13%'
                                                    : isBundleView &&
                                                      !isEquityTemplate
                                                    ? '10%'
                                                    : isSurgery &&
                                                      countryISOCode === 'US'
                                                    ? '13%'
                                                    : isTablet
                                                    ? '13%'
                                                    : '11%'
                                            }
                                        >
                                            {t('common.tableView.quantity')}
                                        </TableHeader>
                                    )}
                                    {!isReviewSubmitScreen &&
                                        !isForSetItem &&
                                        !isFromIndependentProductGuide && (
                                            <TableHeader
                                                className="uom-wrapper"
                                                isSubItem={isSubItem}
                                                width={
                                                    isEquityPage
                                                        ? isSubItem
                                                            ? '6%'
                                                            : '9%'
                                                        : isItemBundlePopup
                                                        ? '11%'
                                                        : isForProductGuide 
                                                            ? ipadAir || ipadMini ? '10%'
                                                            : isForProductGuide && countryISOCode === 'JP' 
                                                            ? '9%'
                                                            : '7%'
                                                        : '7%'
                                                }
                                                textAlign={
                                                    'center'
                                                }
                                                fontSize={
                                                    isForProductGuide && '14px'
                                                }
                                                padding={
                                                    isForProductGuide &&
                                                    '7px 10px'
                                                }
                                                
                                            >
                                                <div
                                                    style={{
                                                        marginRight: '0px',
                                                    }}
                                                >
                                                    {t('common.tableView.uom')}
                                                </div>
                                            </TableHeader>
                                        )}
                                    {isEquityPage && !isSubItem && (
                                        <TableHeader
                                            className="uom"
                                            isSubItem={isSubItem}
                                            width={
                                                isTablet
                                                    ? isEquityPage && '13%'
                                                    : isEquityPage && '9%'
                                            }
                                        >
                                            {`${t(
                                                'common.tableView.unitPrice'
                                            )} ${getCurrencySymbol(
                                                currencyISOCode
                                            )}`}
                                        </TableHeader>
                                    )}
                                    {isEquityPage && !isSubItem && (
                                        <TableHeader
                                            className="uom"
                                            isSubItem={isSubItem}
                                            width={
                                                isTablet
                                                    ? isEquityPage && '12%'
                                                    : isEquityPage && '15%'
                                            }
                                        >
                                            {`${t(
                                                'common.tableView.extPrice'
                                            )} ${getCurrencySymbol(
                                                currencyISOCode
                                            )}`}
                                        </TableHeader>
                                    )}
                                    {!isForProductGuide && !isForSetItem && (
                                        <TableHeader
                                            className="quantity"
                                            isSubItem={isSubItem}
                                            width={
                                                isSubItem && !isEquityTemplate
                                                    ? '5%'
                                                    : isSubItem &&
                                                      isEquityTemplate
                                                    ? '10%'
                                                    : isBundleView &&
                                                      !isEquityTemplate
                                                    ? '5%'
                                                    : isEquityPage
                                                        ? ipadAir || ipadMini ? '7%'
                                                    : '5%'
                                                    : '10%'
                                            }
                                        ></TableHeader>
                                    )}
                                    {isForProductGuide &&
                                        !isFromIndependentProductGuide && (
                                            <TableHeader
                                                className="button-wrapper"
                                                isSubItem={isSubItem}
                                                width={
                                                    isEquityPage
                                                        ? isSubItem
                                                            ? '6%'
                                                            : '9%'
                                                        : isItemBundlePopup
                                                        ? '11%'
                                                        : isForProductGuide
                                                            ?ipadAir || ipadMini ? '10%'
                                                            : '7%'
                                                        : '7%'
                                                }
                                                textAlign={
                                                    isForProductGuide && 'left'
                                                }
                                                fontSize={
                                                    isForProductGuide && '14px'
                                                }
                                                padding={
                                                    isForProductGuide &&
                                                    '7px 10px 7px 35px'
                                                }
                                                
                                            >
                                                
                                            </TableHeader>
                                        )}
                                </>
                            )
                        )}
                        {isForSetItem && (
                            <>
                                <TableHeader
                                    width={
                                        isShippingScreen
                                            ? '15%'
                                            : isReviewSubmitScreenEquity
                                            ? '16%'
                                            : '16%'
                                    }
                                    className="quantityUoM"
                                    isSubItem={isSubItem}
                                >
                                    {t('common.tableView.quantityUom')}
                                </TableHeader>
                                <TableHeader width="7%"></TableHeader>
                            </>
                        )}
                    </tr>
                </TableHeaderContainer>
                <tbody>
                    {products
                        ?.filter((item) => !item?.isTemplateEntryDeleted)
                        ?.map(
                            (item, index) =>
                                (isEquityPage && isCartScreen && !isSubItem
                                    ? ( isQuickOrder ? true : item?.basePrice !== undefined)
                                    : true) && (
                                    <>
                                        <TableRow
                                            key={index}
                                            index={index}
                                            parentIndex={parentIndex}
                                            isSubItem={isSubItem}
                                            isBundleView={isBundleView}
                                            style={{
                                                verticalAlign:
                                                    (item.adjustedExtPrice ||
                                                        item.adjustedUnitPrice) &&
                                                    'top',
                                                borderBottom:
                                                    expandedItems[
                                                        item.productKey || index
                                                    ] ||
                                                    item?.businessRules
                                                        ?.length > 0 ||
                                                    item.batchAllocationError ||
                                                    (isTransferSurgery() &&
                                                        item.status &&
                                                        (countryISOCode === 'JP'
                                                            ? item.status !==
                                                              'Not Allocated'
                                                            : true)) ||
                                                    isSubItem
                                                        ? ''
                                                        : '1px solid #ddd',
                                            }}
                                        >
                                            <TableData
                                            // ipadPadding={'0px'}
                                            // ipadAirPadding={'0px'}
                                                isReviewSubmitScreenEquity={
                                                    isReviewSubmitScreenEquity
                                                }
                                                width={
                                                    isForProductGuide &&
                                                    isForSetItem
                                                        ? '17%'
                                                        : '17%'
                                                }
                                                className="product"
                                                isSubItem={isSubItem}
                                                isScheduleSurgery={isScheduleSurgery}
                                                padding={'8px 10px'}
                                            >
                                                <div
                                                    style={{
                                                        width:
                                                            isSurgery &&
                                                            isTablet
                                                                ? '160px'
                                                                : isSurgery &&
                                                                  '200px',
                                                        display: 'flex',
                                                        flexDirection: 'row',
                                                        whiteSpace: 'nowrap',
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            width:
                                                                isSurgery &&
                                                                isTablet
                                                                    ? '110px'
                                                                    : isSurgery &&
                                                                      '130px',
                                                            paddingRight: '5px',
                                                        }}
                                                    >
                                                        {(item &&
                                                            item.materialType &&
                                                            item.materialType ==
                                                                ITEMSDETAILS[2]
                                                                    .materialType[
                                                                    'bundle'
                                                                ]) ||
                                                        (Object.prototype.hasOwnProperty.call(
                                                            item,
                                                            'bundleItems'
                                                        ) &&
                                                            item.bundleItems
                                                                ?.length >
                                                                0) ? (
                                                            expandedItems[
                                                                item.productKey ||
                                                                    index
                                                            ] ? (
                                                                <UpArrow
                                                                id = {`item.expand-icon-${item.productCFN || item.cfn || item.bom || index}`}
                                                                    onClick={() =>
                                                                        toggleItem(
                                                                            item.productKey ||
                                                                                index
                                                                        )
                                                                    }
                                                                />
                                                            ) : (
                                                                <DownArrow
                                                                id = {`item.collapse-icon-${item.productCFN || item.cfn || item.bom || index}`}
                                                                    onClick={() =>
                                                                        toggleItem(
                                                                            item.productKey ||
                                                                                index
                                                                        )
                                                                    }
                                                                />
                                                            )
                                                        ) : null}
                                                        <span
                                                            style={{
                                                                cursor:
                                                                    isQuickOrder ? 'not-allowed' : 'pointer',
                                                                pointerEvents: isQuickOrder ? 'none' : 'auto',
                                                                color: isQuickOrder
                                                                    ? '#130e4a'
                                                                    : '#1010EB',
                                                                fontWeight:
                                                                    '500',
                                                            }}
                                                            onClick={() => {
                                                                try {
                                                                    handleSetItemClick(
                                                                        item
                                                                    );
                                                                } catch (error) {
                                                                    logErrorToConsole(error);
                                                                }
                                                            }}
                                                            id={`add-cart-btn-${
                                                                item.productCFN ||
                                                                item.cfn ||
                                                                item.bom ||
                                                                ''
                                                            }`}
                                                        >
                                                            {item.productCFN ||
                                                                item.cfn ||
                                                                item.bom}
                                                        </span>
                                                        {(item?.isPlusIconDisable && isQuickOrder) && (
                                                            <NoMatchError>
                                                                {t('scheduleSurgery.quickOrder.noMatchingProductFound')}
                                                            </NoMatchError>
                                                        )}
                                                        {/* {!(
                                                (item.materialType &&
                                                    item.materialType ==
                                                        ITEMSDETAILS[2]
                                                            .materialType[
                                                            'bundle'
                                                        ]) ||
                                                (Object.prototype.hasOwnProperty.call(
                                                    item,
                                                    'bundleItems'
                                                ) &&
                                                    item.bundleItems?.length > 0)
                                            ) &&
                                                item.salesOrg === 'S030' &&
                                                countryISOCode === 'US' && (
                                                    <span>
                                                        <img
                                                            src={TissueItemIcon}
                                                            alt="T"
                                                            style={{
                                                                height: '15px',
                                                                width: '34px',
                                                                marginBottom:
                                                                    '-3px',
                                                            }}
                                                        />
                                                    </span>
                                                )}
                                            {!(
                                                (item.materialType &&
                                                    item.materialType ==
                                                        ITEMSDETAILS[2]
                                                            .materialType[
                                                            'bundle'
                                                        ]) ||
                                                (Object.prototype.hasOwnProperty.call(
                                                    item,
                                                    'bundleItems'
                                                ) &&
                                                    item.bundleItems?.length > 0)
                                            ) &&
                                                item.salesOrg === 'S002' &&
                                                countryISOCode === 'US' && (
                                                    <span>
                                                        <img
                                                            src={
                                                                NonTissueItemIcon
                                                            }
                                                            alt="T"
                                                            style={{
                                                                height: '15px',
                                                                width: '34px',
                                                                marginBottom:
                                                                    '-3px',
                                                            }}
                                                        />
                                                    </span>
                                                )} */}
                                                    </div>
                                                    <div>
                                                        {!isTemplateScreen &&
                                                            !isReviewSubmitScreen &&
                                                            !isReviewSubmitScreenEquity &&
                                                            !isShippingScreen &&
                                                            item.isSet &&
                                                            !isOrderScreen &&
                                                            (productBomDetails.find(
                                                                (bomDetail) =>
                                                                    bomDetail.prodcutCFN ===
                                                                    item.productCFN
                                                            )
                                                                ?.billOfMaterialsHistory ? (
                                                                <span id = {`item-bom-icon-${item.productCFN || item.cfn || item.bom || index}`}
                                                                    style={{
                                                                        cursor: 'pointer',
                                                                    }}
                                                                    onClick={() =>
                                                                        onBomClick(
                                                                            item
                                                                        )
                                                                    }
                                                                >
                                                                    {' '}
                                                                    <img
                                                                        src={
                                                                            BOMChanges
                                                                        }
                                                                        alt="BOM"
                                                                        width="25px"
                                                                        height="15px"
                                                                        style={{
                                                                            marginLeft:
                                                                                winWidth >=
                                                                                    '768' &&
                                                                                winWidth <
                                                                                    '900'
                                                                                    ? '0'
                                                                                    : '-5px',
                                                                            marginBottom:
                                                                                '-2px',
                                                                        }}
                                                                    />
                                                                </span>
                                                            ) : (
                                                                <div
                                                                    style={{
                                                                        width:
                                                                            isSurgery &&
                                                                            '20px',
                                                                    }}
                                                                ></div>
                                                            ))}
                                                    </div>
                                                    <div>
                                                        {item?.isReservationSet &&
                                                        !isOrderScreen &&
                                                        !isTemplateScreen ? (
                                                            <span>
                                                                <img
                                                                    src={
                                                                        StorageRequest
                                                                    }
                                                                    alt="storage-request"
                                                                    width="25px"
                                                                    height="15px"
                                                                    style={{
                                                                        marginLeft:
                                                                            '0',
                                                                        marginBottom:
                                                                            '-3px',
                                                                    }}
                                                                />
                                                            </span>
                                                        ) : (
                                                            <div
                                                                style={{
                                                                    width:
                                                                        isSurgery &&
                                                                        '24px',
                                                                }}
                                                            ></div>
                                                        )}
                                                        {/* {!isOrderScreen && (
                                        <div style={{ marginTop: '2px' }}>
                                            {!isReviewSubmitScreen &&
                                                !isReviewSubmitScreenEquity &&
                                                productBomDetails.find(
                                                    (bomDetail) =>
                                                        bomDetail.prodcutCFN ===
                                                        item.productCFN
                                                )?.billOfMaterialsHistory ? (
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        // marginLeft: '10px',
                                                    }}
                                                >
                                                    <img
                                                        src={AlertCircleOutlinePink}
                                                        height="14px"
                                                        width="14px"
                                                        style={{
                                                            // cursor: 'pointer',
                                                            marginTop: '1.1px',
                                                        }}
                                                    />
                                                    <span
                                                        style={{
                                                            color: '#e59b05',
                                                            // cursor: 'pointer',
                                                            fontSize: '13px',
                                                            fontWeight: '600',
                                                            marginLeft: '5px',
                                                            marginTop: '-1.3px',
                                                        }}
                                                    >
                                                        BoM Change
                                                    </span>
                                                </div>
                                            ) : null}
                                        </div>
                                    )} */}
                                                    </div>
                                                </div>
                                            </TableData>
                                            {countryISOCode === 'US' &&
                                                !isForProductGuide &&
                                                !isForSetItem && (
                                                    <TableData>
                                                        <div
                                                            style={{
                                                                display: 'flex',
                                                                marginLeft:
                                                                    '5px',
                                                            }}
                                                        >
                                                            {!(
                                                                (item.materialType &&
                                                                    item.materialType ==
                                                                        ITEMSDETAILS[2]
                                                                            .materialType[
                                                                            'bundle'
                                                                        ]) ||
                                                                (Object.prototype.hasOwnProperty.call(
                                                                    item,
                                                                    'bundleItems'
                                                                ) &&
                                                                    item
                                                                        .bundleItems
                                                                        ?.length >
                                                                        0)
                                                            ) &&
                                                                item.salesOrg ===
                                                                    'S030' &&
                                                                countryISOCode ===
                                                                    'US' && (
                                                                    <span>
                                                                        <img
                                                                            src={
                                                                                TissueItemIcon
                                                                            }
                                                                            alt="T"
                                                                            style={{
                                                                                height: '15px',
                                                                                width: '34px',
                                                                                marginBottom:
                                                                                    '-3px',
                                                                            }}
                                                                        />
                                                                    </span>
                                                                )}
                                                            {!(
                                                                (item.materialType &&
                                                                    item.materialType ==
                                                                        ITEMSDETAILS[2]
                                                                            .materialType[
                                                                            'bundle'
                                                                        ]) ||
                                                                (Object.prototype.hasOwnProperty.call(
                                                                    item,
                                                                    'bundleItems'
                                                                ) &&
                                                                    item
                                                                        .bundleItems
                                                                        ?.length >
                                                                        0)
                                                            ) &&
                                                                item.salesOrg ===
                                                                    'S002' &&
                                                                countryISOCode ===
                                                                    'US' && (
                                                                    <span>
                                                                        <img
                                                                            src={
                                                                                NonTissueItemIcon
                                                                            }
                                                                            alt="T"
                                                                            style={{
                                                                                height: '15px',
                                                                                width: '34px',
                                                                                marginBottom:
                                                                                    '-3px',
                                                                            }}
                                                                        />
                                                                    </span>
                                                                )}
                                                        </div>
                                                    </TableData>
                                                )}

                                            {/*                              
                                <TableData>
                                    {!isTemplateScreen &&
                                        !isReviewSubmitScreen &&
                                        !isReviewSubmitScreenEquity &&
                                        !isShippingScreen &&
                                        item.isSet &&
                                        !isOrderScreen &&
                                        (productBomDetails.find(
                                            (bomDetail) =>
                                                bomDetail.prodcutCFN ===
                                                item.productCFN
                                        )?.billOfMaterialsHistory ? (
                                            <span
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => onBomClick(item)}
                                            >
                                                {' '}
                                                <img
                                                    src={BOMChanges}
                                                    alt="BOM"
                                                    width="25px"
                                                    height="15px"
                                                    style={{
                                                        marginLeft:
                                                            winWidth >= '768' &&
                                                            winWidth < '900'
                                                                ? '0'
                                                                : '-5px',
                                                        marginBottom: '-2px',
                                                    }}
                                                />
                                            </span>
                                        ) : null)}
                                </TableData> */}

                                            <TableData
                                            ipadPaddingLeft={'10px !important'}
                                            ipadAirPaddingLeft={'10px !important'}
                                            
                                                isReviewSubmitScreenEquity={
                                                    isReviewSubmitScreenEquity
                                                }
                                                width={
                                                    isReviewSubmitScreen ||
                                                    isReviewSubmitScreenEquity
                                                        ? isReviewSubmitScreenEquity
                                                            ? '47%'
                                                            : '20%'
                                                        : isForProductGuide &&
                                                          isForSetItem
                                                        ? '45%'
                                                        : '36%'
                                                }
                                                isForProductGuide = {isForProductGuide}
                                                isFromSetItemDetailsLists = {isFromSetItemDetailsLists}
                                                // paddingLeft={
                                                //     isForSetItem && '4%'
                                                // }
                                                className="description"
                                            >
                                                {item.description && (
                                                    <TruncatedTooltip
                                                        isOrderScreen={
                                                            isOrderScreen
                                                        }
                                                        isTemplateScreen={
                                                            isTemplateScreen
                                                        }
                                                        text={item.description}
                                                        maxLength={getMaxLength(
                                                            'description'
                                                        )}
                                                        productCfn={
                                                            item.productCFN ||
                                                            item.cfn ||
                                                            item.bom
                                                        }
                                                    />
                                                )}
                                            </TableData>
                                            {(isTemplateScreen ||
                                                isOrderScreen) && (
                                                <>
                                                    {!(
                                                        Object.prototype.hasOwnProperty.call(
                                                            item,
                                                            'bundleItems'
                                                        ) &&
                                                        item.bundleItems
                                                            ?.length > 0
                                                    ) && (
                                                        <TableData
                                                            width="15%"
                                                            className="brand"
                                                        >
                                                            {item.brand && (
                                                                <TruncatedTooltip
                                                                    isOrderScreen={
                                                                        isOrderScreen
                                                                    }
                                                                    isTemplateScreen={
                                                                        isTemplateScreen
                                                                    }
                                                                    text={
                                                                        item?.brand &&
                                                                        item?.brand !=
                                                                            ''
                                                                            ? typeof item?.brand ===
                                                                              'string'
                                                                                ? item.brand
                                                                                : item
                                                                                      ?.brand[0]
                                                                            : ''
                                                                    }
                                                                    maxLength={getMaxLength(
                                                                        'brand'
                                                                    )}
                                                                    productCfn={
                                                                        item.productCFN ||
                                                                        item.cfn ||
                                                                        item.bom
                                                                    }
                                                                    isBrand={
                                                                        true
                                                                    }
                                                                />
                                                            )}
                                                        </TableData>
                                                    )}
                                                    {Object.prototype.hasOwnProperty.call(
                                                        item,
                                                        'bundleItems'
                                                    ) &&
                                                        item.bundleItems
                                                            ?.length > 0 && (
                                                            <TableData
                                                                width="15%"
                                                                className="brand"
                                                                padding={
                                                                    '8px 13px'
                                                                }
                                                            >
                                                                {item
                                                                    ?.bundleItems
                                                                    ?.length > 0
                                                                    ? item
                                                                          .bundleItems
                                                                          ?.length
                                                                    : ''}
                                                            </TableData>
                                                        )}
                                                    {isOrderScreen &&
                                                        !isSubItem &&
                                                        !isItemListView &&
                                                        orderType !== 'KE' &&
                                                        orderType !== 'KB' && (
                                                            <TableData>
                                                                {item.status}
                                                            </TableData>
                                                        )}
                                                    <TableData
                                                        width="16%"
                                                        className="quantityUoM"
                                    isTemplateScreen={isTemplateScreen && !isFromTemplates}
                                                    >
                                                        {item.quantity} X{' '}
                                                        <Type
                                                            style={{
                                                                fontSize:
                                                                    '12px',
                                                            }}
                                                        >
                                                            {/* {item.uom} */}
                                                            {item.isSet
                                                                ? t(
                                                                      'common.setLabel'
                                                                  )
                                                                : item.uom}
                                                        </Type>
                                                    </TableData>
                                                    {!isOrderScreen &&
                                                        !isFromTemplates && (
                                                            <TableData className="quantity">
                                                                <TemplateCheckBox
                                                                    isCondensedView={
                                                                        isCondensedView
                                                                    }
                                                                    isAddToBundle={
                                                                        isAddToBundle
                                                                    }
                                                                    isTemplateScreen={isTemplateScreen && !isFromTemplates}
                                                                    item={item}
                                                                    checkBoxDetails={{
                                                                        name: item.cfn,
                                                                        id: item.description,
                                                                        onChange:
                                                                            () => {
                                                                                (item &&
                                                                                    item.materialType &&
                                                                                    item.materialType ==
                                                                                        ITEMSDETAILS[2]
                                                                                            .materialType[
                                                                                            'bundle'
                                                                                        ]) ||
                                                                                isSubItem
                                                                                    ? handleCheckBoxSelection(
                                                                                          isSubItem
                                                                                              ? item.cfn
                                                                                              : item.productKey,
                                                                                          !item.isChecked,
                                                                                          isSubItem
                                                                                              ? 'children'
                                                                                              : 'parent',
                                                                                          isSubItem
                                                                                              ? productKeyBundle
                                                                                              : '',
                                                                                          !item.isChecked
                                                                                      )
                                                                                    : handleCheckBoxSelection(
                                                                                          item.productKey,
                                                                                          !item.isChecked
                                                                                      );
                                                                            },
                                                                        checked:
                                                                            item.isChecked,
                                                                    }}
                                                                    productWithIsPlaceHolderSet={
                                                                        productWithIsPlaceHolderSet
                                                                    }
                                                                />
                                                            </TableData>
                                                        )}
                                                </>
                                            )}
                                            {isReviewSubmitScreen && (
                                                <TableData
                                                    width="16%"
                                                    className="brand"
                                                >
                                                    {item.brand && (
                                                        <TruncatedTooltip
                                                            text={
                                                                item?.brand &&
                                                                item?.brand !=
                                                                    ''
                                                                    ? typeof item?.brand ===
                                                                      'string'
                                                                        ? item.brand
                                                                        : item
                                                                              ?.brand[0]
                                                                    : ''
                                                            }
                                                            maxLength={getMaxLength(
                                                                'brand'
                                                            )}
                                                            productCfn={
                                                                item.productCFN ||
                                                                item.cfn ||
                                                                item.bom
                                                            }
                                                            isOrderScreen={
                                                                isOrderScreen
                                                            }
                                                            isBrand={true}
                                                        />
                                                    )}
                                                </TableData>
                                            )}
                                            {isReviewSubmitScreenEquity &&
                                                !isBundleView && (
                                                    <TableData
                                                        isReviewSubmitScreenEquity={
                                                            isReviewSubmitScreenEquity
                                                        }
                                                        width="16%"
                                                        className="brand"
                                                    >
                                                        {item.brand && (
                                                            <TruncatedTooltip
                                                                text={
                                                                    item?.brand &&
                                                                    item?.brand !=
                                                                        ''
                                                                        ? typeof item?.brand ===
                                                                          'string'
                                                                            ? item.brand
                                                                            : item
                                                                                  ?.brand[0]
                                                                        : ''
                                                                }
                                                                maxLength={getMaxLength(
                                                                    'brand'
                                                                )}
                                                                productCfn={
                                                                    item.productCFN ||
                                                                    item.cfn ||
                                                                    item.bom
                                                                }
                                                                isOrderScreen={
                                                                    isOrderScreen
                                                                }
                                                                isBrand={true}
                                                            />
                                                        )}
                                                    </TableData>
                                                )}
                                            {isReviewSubmitScreenEquity &&
                                                isBundleView && (
                                                    <TableData
                                                        width="16%"
                                                        className="brand"
                                                        padding={'8px 13px'}
                                                    >
                                                        {item?.children
                                                            ?.length > 0
                                                            ? item.children
                                                                  .length
                                                            : ''}
                                                    </TableData>
                                                )}
                                            {isShippingScreen ||
                                            isReviewSubmitScreen ||
                                            isReviewSubmitScreenEquity ? (
                                                <>
                                                    <TableData
                                                        isReviewSubmitScreenEquity={
                                                            isReviewSubmitScreenEquity
                                                        }
                                                        width={
                                                            isReviewSubmitScreenEquity
                                                                ? '12%'
                                                                : '16%'
                                                        }
                                                        className="quantityUoM"
                                                    >
                                                        {item.quantity} X{' '}
                                                        <Type
                                                            style={{
                                                                fontSize:
                                                                    '12px',
                                                            }}
                                                        >
                                                            {item.isSet
                                                                ? t(
                                                                      'common.setLabel'
                                                                  )
                                                                : item.uom}
                                                        </Type>
                                                    </TableData>
                                                    {isReviewSubmitScreenEquity &&
                                                        !isSubItem && (
                                                            <TableData
                                                                isReviewSubmitScreenEquity={
                                                                    isReviewSubmitScreenEquity
                                                                }
                                                                className="price"
                                                                width={
                                                                    isReviewSubmitScreenEquity &&
                                                                    '12%'
                                                                }
                                                            >
                                                                <div
                                                                    style={{
                                                                        textDecoration:
                                                                            item.adjustedUnitPrice &&
                                                                            'line-through',
                                                                        color:
                                                                            item.adjustedUnitPrice &&
                                                                            '#E5047E',
                                                                    }}
                                                                >
                                                                    {setCurrencyFormatWithoutSymbol(
                                                                        item.basePrice
                                                                    )}
                                                                </div>
                                                                {item.adjustedUnitPrice && (
                                                                    <div>
                                                                        {setCurrencyFormatWithoutSymbol(
                                                                            item.adjustedUnitPrice
                                                                        )}
                                                                    </div>
                                                                )}
                                                            </TableData>
                                                        )}
                                                    {isReviewSubmitScreenEquity &&
                                                        !isSubItem && (
                                                            <TableData
                                                                isReviewSubmitScreenEquity={
                                                                    isReviewSubmitScreenEquity
                                                                }
                                                                className="price"
                                                                width={
                                                                    isReviewSubmitScreenEquity &&
                                                                    '12%'
                                                                }
                                                            >
                                                                <div
                                                                    style={{
                                                                        textDecoration:
                                                                            item.adjustedExtPrice &&
                                                                            'line-through',
                                                                        color:
                                                                            item.adjustedExtPrice &&
                                                                            '#E5047E',
                                                                    }}
                                                                >
                                                                    {setCurrencyFormatWithoutSymbol(
                                                                        item.extPrice
                                                                    )}
                                                                </div>
                                                                {item.adjustedExtPrice && (
                                                                    <div>
                                                                        {setCurrencyFormatWithoutSymbol(
                                                                            item.adjustedExtPrice
                                                                        )}
                                                                    </div>
                                                                )}
                                                                {item.discount && (
                                                                    <div
                                                                        style={{
                                                                            whiteSpace:
                                                                                'nowrap',
                                                                            marginLeft:
                                                                                '-27%',
                                                                            color: '#E5047E',
                                                                        }}
                                                                    >
                                                                        {`${
                                                                            item.discount
                                                                        }${t(
                                                                            'equity.common.feesAndItems.discount'
                                                                        )}`}
                                                                    </div>
                                                                )}
                                                            </TableData>
                                                        )}
                                                    {!isReviewSubmitScreen &&
                                                        !isReviewSubmitScreenEquity &&
                                                        showDontShip && (
                                                            <TableData className="quantity" padding={'0 0 0 10px'}>
                                                                {shipDontShipSurgery !==
                                                                    'NOT_VISIBLE' &&
                                                                    item?.isSet &&
                                                                    !item.isReservationSet &&
                                                                    (isTransferSurgery() &&
                                                                    item.status &&
                                                                    (countryISOCode ===
                                                                    'JP'
                                                                        ? item.status !==
                                                                          'Not Allocated'
                                                                        : true) ? (
                                                                        <CheckBoxTransfer
                                                                            item={
                                                                                item
                                                                            }
                                                                            inventoryShipping={
                                                                                inventoryShipping
                                                                            }
                                                                            countryISOCode={
                                                                                countryISOCode
                                                                            }
                                                                            handleLocationChange={
                                                                                handleLocationChange
                                                                            }
                                                                            checked={
                                                                                !item.shippingRequirement
                                                                            }
                                                                            selectedLocation={
                                                                                selectedLocation
                                                                            }
                                                                            allocatedData={
                                                                                allocatedData
                                                                            }
                                                                            isShowCheckBox={
                                                                                true
                                                                            }
                                                                            isMessageDisplay={
                                                                                false
                                                                            }
                                                                            isShowLabelEmpty={
                                                                                true
                                                                            }
                                                                            isShowDropDown={
                                                                                false
                                                                            }
                                                                        />
                                                                    ) : (
                                                                        <Checkbox
                                                                            checked={!item.shippingRequirement}
                                                                            onCheckboxSelectionChange={() => {
                                                                                try {
                                                                                    if (
                                                                                        !inventoryShipping
                                                                                    ) {
                                                                                        handleLocationChange(
                                                                                            item.productKey,
                                                                                            !item.shippingRequirement
                                                                                        );
                                                                                    }
                                                                                } catch (error) {
                                                                                    logErrorToConsole(error);
                                                                                }
                                                                            }}
                                                                            disabled={inventoryShipping}
                                                                            id = 'dont-ship-shipping-requirement-checkbox'
                                                                            margin={'0 6px 0 0'}
                                                                            labelStyleObj={{
                                                                                fontSize: SEMANTIC_TEXT_SMALL_PX,
                                                                                fontFamily: FONT_FAMILY_DEMI,
                                                                                color: DARK_NAVY_FONT_COLOR,
                                                                            }}
                                                                            background={'none'}
                                                                            checkboxBorder={'1.5px solid #555555'}
                                                                            alignItemDirection={'center'}
                                                                            hoverEffect={'false'}
                                                                            disableFocusEffect={'true'}
                                                                        />
                                                                    ))}
                                                            </TableData>
                                                        )}
                                                    <TableData
                                                        width={
                                                            isShippingScreen
                                                                ? '28%'
                                                                : '18%'
                                                        }
                                                        className="batch"
                                                    >
                                                        {isShippingScreen &&
                                                            showDontShip &&
                                                            (shipDontShipSurgery !==
                                                                'NOT_VISIBLE' ||
                                                                item.isReservationSet) && (
                                                                <BatchDropDown
                                                                    checkAll={
                                                                        checkAll
                                                                    }
                                                                    checked={
                                                                        !item.shippingRequirement
                                                                    }
                                                                    countryISOCode={
                                                                        countryISOCode
                                                                    }
                                                                    selectedLocation={
                                                                        selectedLocation
                                                                    }
                                                                    setIsBatchSelected={
                                                                        setIsBatchSelected
                                                                    }
                                                                    isBatchSelected={
                                                                        isBatchSelected
                                                                    }
                                                                    allocatedData={
                                                                        allocatedData
                                                                    }
                                                                    setAllocatedData={
                                                                        setAllocatedData
                                                                    }
                                                                    setReservationBatch={
                                                                        setReservationBatch
                                                                    }
                                                                    product={
                                                                        item
                                                                    }
                                                                    isShowCheckBox={
                                                                        false
                                                                    }
                                                                    isMessageDisplay={
                                                                        false
                                                                    }
                                                                    isShowLabelEmpty={
                                                                        false
                                                                    }
                                                                    isShowSetLocation={
                                                                        false
                                                                    }
                                                                    isShowDropDown={
                                                                        true
                                                                    }
                                                                />
                                                            )}
                                                    </TableData>
                                                </>
                                            ) : (
                                                !isTemplateScreen &&
                                                !isOrderScreen && (
                                                    <>
                                                        {!isBundleView && (
                                                            <TableData
                                                                width={
                                                                    isForProductGuide &&
                                                                    isForSetItem
                                                                        ? '20%'
                                                                        : '16%'
                                                                }
                                                                padding={(isSurgery && isCartScreen) ? '8px 10px' : isScheduleSurgery? '8px 10px' : ''}
                                                                className="brand"
                                                            >
                                                                {item.brand && (
                                                                    <TruncatedTooltip
                                                                        text={
                                                                            item?.brand &&
                                                                            item?.brand !=
                                                                                ''
                                                                                ? typeof item?.brand ===
                                                                                  'string'
                                                                                    ? item.brand
                                                                                    : item
                                                                                          ?.brand[0]
                                                                                : ''
                                                                        }
                                                                        maxLength={getMaxLength(
                                                                            'brand'
                                                                        )}
                                                                        productCfn={
                                                                            item.productCFN ||
                                                                            item.cfn ||
                                                                            item.bom
                                                                        }
                                                                        isOrderScreen={
                                                                            isOrderScreen
                                                                        }
                                                                        isBrand={
                                                                            true
                                                                        }
                                                                    />
                                                                )}
                                                            </TableData>
                                                        )}
                                                        {isBundleView && (
                                                            <TableData
                                                                width="15%"
                                                                className="brand"
                                                                padding={
                                                                    '8px 13px'
                                                                }
                                                            >
                                                                {item?.children
                                                                    ?.length >
                                                                    0 ||
                                                                item
                                                                    ?.bundleItems
                                                                    ?.length > 0
                                                                    ? item
                                                                          ?.children
                                                                          ?.length ||
                                                                      item
                                                                          ?.bundleItems
                                                                          ?.length
                                                                    : ''}
                                                            </TableData>
                                                        )}
                                                        {!isForProductGuide &&
                                                            !isForSetItem && (
                                                                <TableData
                                                                    className="quantity"
                                                                    width={
                                                                        isBundleView &&
                                                                        '13%'
                                                                    }
                                                                >
                                                                    <ActionButton>
                                                                        <>
                                                                            <AddCartButton
                                                                                className={
                                                                                    item.quantity <=
                                                                                        0 ||
                                                                                    item.isPlaceHolderAdded ||
                                                                                    item.isDeleteButtonPresent ===
                                                                                        false
                                                                                        ? 'disabled'
                                                                                        : ''
                                                                                }
                                                                                width={
                                                                                    '20px'
                                                                                }
                                                                                height={
                                                                                    '29px'
                                                                                }
                                                                                border={
                                                                                    'unset'
                                                                                }
                                                                                visibility={
                                                                                    item.isDeleteButtonPresent ===
                                                                                    false
                                                                                        ? 'hidden'
                                                                                        : ''
                                                                                }
                                                                                id = {`item-decrease-quantity-${item.productCFN || item.cfn || item.bom || index}`}
                                                                                style={{ marginLeft: '-6px' }}
                                                                                onClick={() => {
                                                                                    try {
                                                                                        if (
                                                                                            moreTemplates
                                                                                        ) {
                                                                                            if (
                                                                                                isSubItem
                                                                                            ) {
                                                                                                removeCount(
                                                                                                    item.productKey,
                                                                                                    item.isSet,
                                                                                                    index,
                                                                                                    item.quantity,
                                                                                                    item.productKey,
                                                                                                    true,
                                                                                                    'Bundle',
                                                                                                    productKeyBundle
                                                                                                );
                                                                                            } else {
                                                                                                removeCount(
                                                                                                    item.cfn,
                                                                                                    item.isSet,
                                                                                                    index
                                                                                                    // item.quantity,
                                                                                                    // item.productKey,
                                                                                                    // true
                                                                                                );
                                                                                            }
                                                                                        } else {
                                                                                            if (
                                                                                                isSubItem
                                                                                            ) {
                                                                                                removeCount(
                                                                                                    item.productKey,
                                                                                                    item.isSet,
                                                                                                    item,
                                                                                                    productKeyBundle
                                                                                                );
                                                                                            } else if (
                                                                                                isItemBundlePopup
                                                                                            ) {
                                                                                                removeCount(
                                                                                                    item
                                                                                                );
                                                                                            } else {
                                                                                                removeCount(
                                                                                                    item.productKey ??
                                                                                                        item.cfn, // use productKey if exists, else cfn
                                                                                                    item.isSet, // pass isSet if exists, else undefined
                                                                                                    item // pass item itself
                                                                                                );
                                                                                            }
                                                                                        }
                                                                                    } catch (error) {
                                                                                        logErrorToConsole(error);
                                                                                    }
                                                                                }}
                                                                                shadow={
                                                                                    'none'
                                                                                }
                                                                            >
                                                                                <RemoveIcon />
                                                                            </AddCartButton>
                                                                        </>
                                                                         {isEquityPage ||
                                                                isEquityTemplate ? (
                                                                    <InputBox
                                                                        type="text"
                                                                        disabled={item.isPlusIconDisable && isQuickOrder}
                                                                            
                                                                        value={
                                                                            item.quantity ===
                                                                            '0'
                                                                                ? ''
                                                                                : item.quantity
                                                                        }
                                                                        onChange={(
                                                                            e
                                                                        ) => {
                                                                            validateQuantity(
                                                                                e
                                                                                    .target
                                                                                    .value,
                                                                                productKeyBundle,
                                                                                item?.productKey
                                                                            );
                                                                        }}
                                                                    />
                                                                ) : (
                                                                        <CounterDiv
                                                                            color={
                                                                                '#030330'
                                                                            }
                                                                            style={{
                                                                                fontFamily:
                                                                                    'AvenirNextWorld Regular',
                                                                                fontSize:
                                                                                    '14px',
                                                                            }}
                                                                            margin= {isTablet ? '0 10px' : '0 15px'}
                                                                        >
                                                                            {
                                                                                item.quantity
                                                                            }
                                                                        </CounterDiv>
                                                                )}
                                                                        <>
                                                                            <AddCartButton
                                                                                className={
                                                                                    isQuickOrder
                                                                                        ? (item.isPlusIconDisable
                                                                                            ? 'disabled'
                                                                                            : item.quantity >= 50 || item.isPlaceHolderAdded || (!item.isSet && item.isDeleteButtonPresent === false)
                                                                                                ? 'disabled'
                                                                                                : '')
                                                                                        // : (isEquityPage || isEquityTemplate
                                                                                        //     ? ''
                                                                                            : (item.quantity >= 50 || item.isPlaceHolderAdded || (!item.isSet && item.isDeleteButtonPresent === false)
                                                                                                ? 'disabled'
                                                                                                : '')
                                                                                }
                                                                                visibility={
                                                                                    isEquityPage ||
                                                                                    isEquityTemplate
                                                                                        ? ''
                                                                                        : !item.isSet &&
                                                                                          item.isDeleteButtonPresent ===
                                                                                              false
                                                                                        ? 'hidden'
                                                                                        : ''
                                                                                }
                                                                                width={
                                                                                    '20px'
                                                                                }
                                                                                height={
                                                                                    '29px'
                                                                                }
                                                                                border={
                                                                                    'unset'
                                                                                }
                                                                                id = {`item-increase-quantity-${item.productCFN || item.cfn || item.bom || index}`}
                                                                                onClick={() => {
                                                                                    try {
                                                                                        if (
                                                                                            moreTemplates
                                                                                        ) {
                                                                                            if (
                                                                                                isEquityTemplate
                                                                                            ) {
                                                                                                if (
                                                                                                    isSubItem
                                                                                                ) {
                                                                                                    addCount(
                                                                                                        item.productKey,
                                                                                                        item.isSet,
                                                                                                        '',
                                                                                                        item.quantity,
                                                                                                        'bundle',
                                                                                                        productKeyBundle
                                                                                                    );
                                                                                                } else {
                                                                                                    addCount(
                                                                                                        item.cfn,
                                                                                                        item.isSet,
                                                                                                        '',
                                                                                                        item.quantity
                                                                                                    );
                                                                                                }
                                                                                            } else {
                                                                                                addCount(
                                                                                                    item
                                                                                                    // item.isSet,
                                                                                                    // item.quantityValue
                                                                                                );
                                                                                            }
                                                                                        } else {
                                                                                            if (
                                                                                                isSubItem
                                                                                            ) {
                                                                                                addCount(
                                                                                                    item,
                                                                                                    productKeyBundle
                                                                                                );
                                                                                            } else if (
                                                                                                isItemBundlePopup
                                                                                            ) {
                                                                                                addCount(
                                                                                                    item
                                                                                                );
                                                                                            } else {
                                                                                                addCount(
                                                                                                    item
                                                                                                );
                                                                                            }
                                                                                        }
                                                                                    } catch (error) {
                                                                                        logErrorToConsole(error);
                                                                                    }
                                                                                }}
                                                                                shadow={
                                                                                    'none'
                                                                                }
                                                                            >
                                                                                <AddIcon />
                                                                            </AddCartButton>
                                                                        </>
                                                                    </ActionButton>
                                                                </TableData>
                                                            )}
                                                        {!isForProductGuide &&
                                                            !isForSetItem && (
                                                                <TableData
                                                                    width={
                                                                        isEquityPage
                                                                            ? isSubItem &&
                                                                              '6%'
                                                                            : isItemBundlePopup
                                                                            ? '11%'
                                                                            : ipadAir || ipadMini ? '9%'
                                                                            : '5%'
                                                                    }
                                                                    alignCenter={true}
                                                                    className="quantity"
                                                                >
                                                                    {item?.isSet || item?.uom ?
                                                                    <Type
                                                                        marginLeft={'0px'}
                                                                        style={{
                                                                            fontSize:
                                                                                '12px',
                                                                        }}
                                                                    >
                                                                        {item.isSet
                                                                            ? t(
                                                                                  'common.setLabel'
                                                                              )
                                                                            : item.uom}
                                                                    </Type>
                                                                    : null}
                                                                </TableData>
                                                            )}
                                                        {isForProductGuide &&
                                                            !isForSetItem &&
                                                            !isFromIndependentProductGuide && (
                                                                <TableData
                                                                    width={
                                                                        '10%'
                                                                    }
                                                                    isScheduleSurgery={isScheduleSurgery}
                                                                    textAlign= {'center'}
                                                                >
                                                                    <Type marginRight = {'0px'} marginLeft = {'0px'}>
                                                                        {item.isSet
                                                                        ? t(
                                                                            'common.setLabel'
                                                                        )
                                                                        : item.uom}
                                                                    </Type>
                                                                </TableData>
                                                            )}

                                                        {isForProductGuide &&
                                                            !isForSetItem &&
                                                            !isFromIndependentProductGuide && (
                                                                <TableData
                                                                    width={
                                                                        '10%'
                                                                    }
                                                                    isScheduleSurgery={isScheduleSurgery}
                                                                >
                                                                    <ActionButton>
                                                                        {item.productAdded ? (
                                                                            <AddCartButton>
                                                                                <CheckMarkImg
                                                                                    src={
                                                                                        CheckMark
                                                                                    }
                                                                                />
                                                                            </AddCartButton>
                                                                        ) : null}
                                                                        {!item.productAdded && (
                                                                            <>                                                                                <AddCartButton
                                                                                    onClick={() => {
                                                                                        try {
                                                                                            const itemKey = item.cfn || item.productCFN || item.id;
                                                                                            if (!isClickAllowed(itemKey)) {
                                                                                                return;
                                                                                            }
                                                                                            if (handleAddToCartSynchronized) {
                                                                                                handleAddToCartSynchronized(item);
                                                                                            } else {
                                                                                                setProductToBeAdded(item);
                                                                                                productValidation([item]);
                                                                                            }
                                                                                        } catch (error) {
                                                                                            logErrorToConsole(error);
                                                                                        }
                                                                                    }}
                                                                                    id= {`add-cart-btn-${item.cfn || item.bom || ''}`} 
                                                                                   
                                                                                >
                                                                                    <AddCartIcon
                                                                                        mobilePath={
                                                                                            StepperAddBlue
                                                                                        }
                                                                                        width={
                                                                                            '19px'
                                                                                        }
                                                                                        height={
                                                                                            '19px'
                                                                                        }
                                                                                    />
                                                                                </AddCartButton>
                                                                            </>
                                                                        )}
                                                                    </ActionButton>
                                                                </TableData>
                                                            )}
                                                        {isEquityPage &&
                                                            !isSubItem && (
                                                                <TableData className="price">
                                                                    <div
                                                                        style={{
                                                                            textDecoration:
                                                                                item.adjustedUnitPrice &&
                                                                                'line-through',
                                                                            color:
                                                                                item.adjustedUnitPrice &&
                                                                                '#E5047E',
                                                                        }}
                                                                    >
                                                                        {setCurrencyFormatWithoutSymbol(
                                                                            item.basePrice
                                                                        )}
                                                                    </div>
                                                                    {item.adjustedUnitPrice && (
                                                                        <div>
                                                                            {setCurrencyFormatWithoutSymbol(
                                                                                item.adjustedUnitPrice
                                                                            )}
                                                                        </div>
                                                                    )}
                                                                </TableData>
                                                            )}
                                                        {isForSetItem && (
                                                            <TableData
                                                                isReviewSubmitScreenEquity={
                                                                    isReviewSubmitScreenEquity
                                                                }
                                                                width={
                                                                    isReviewSubmitScreenEquity
                                                                        ? '12%'
                                                                        : '16%'
                                                                }
                                                                className="quantityUoM"
                                                            >
                                                                {item?.isSet ? (
                                                                    <Type
                                                                        style={{
                                                                            fontSize:
                                                                                '12px',
                                                                        }}
                                                                    >
                                                                        {t(
                                                                            'common.setLabel'
                                                                        )}
                                                                    </Type>
                                                                ) : (
                                                                    <>
                                                                        {
                                                                            item.quantity
                                                                        }{' '}
                                                                        X{' '}
                                                                        <Type
                                                                            style={{
                                                                                fontSize:
                                                                                    '12px',
                                                                            }}
                                                                        >
                                                                            {
                                                                                item.uom
                                                                            }
                                                                        </Type>
                                                                    </>
                                                                )}
                                                            </TableData>
                                                        )}

                                                        {isForSetItem && (
                                                            <TableData>
                                                                {!(
                                                                    isConsignmentAdd ||
                                                                    isEquity
                                                                ) &&
                                                                    isOnlyPlusButton &&
                                                                    isForSetItem && (
                                                                        <ActionButton>
                                                                            {item?.productAdded && (
                                                                                <img
                                                                                    src={
                                                                                        CheckMark
                                                                                    }
                                                                                    width={
                                                                                        '30px'
                                                                                    }
                                                                                    height={
                                                                                        '30px'
                                                                                    }
                                                                                    alt="Added"
                                                                                />
                                                                            )}
                                                                            {!item?.productAdded && (
                                                                                <AddedCartButton
                                                                                    id={`add-cart-btn-${
                                                                                        item.cfn ||
                                                                                        item.bom ||
                                                                                        ''
                                                                                    }`}
                                                                                    width={
                                                                                        '29px'
                                                                                    }
                                                                                    height={
                                                                                        '29px'
                                                                                    }
                                                                                    border={
                                                                                        'unset'
                                                                                    }                                                                                    onClick={() => {
                                                                                        try {
                                                                                            const itemKey = item.cfn || item.productCFN || item.id;
                                                                                            if (!isClickAllowed(itemKey)) {
                                                                                                return;
                                                                                            }
                                                                                            if (handleAddToCartSynchronized) {
                                                                                                handleAddToCartSynchronized(item);
                                                                                            } else {
                                                                                                setProductToBeAdded(item);
                                                                                                productValidation([item]);
                                                                                            }
                                                                                        } catch (error) {
                                                                                            logErrorToConsole(error);
                                                                                        }
                                                                                    }}
                                                                                >
                                                                                    <AddCartIcon
                                                                                        mobilePath={
                                                                                            StepperAddBlue
                                                                                        }
                                                                                        width={
                                                                                            '19px'
                                                                                        }
                                                                                        height={
                                                                                            '19px'
                                                                                        }
                                                                                    />
                                                                                </AddedCartButton>
                                                                            )}
                                                                        </ActionButton>
                                                                    )}
                                                            </TableData>
                                                        )}

                                                        {isEquityPage &&
                                                            !isSubItem && (
                                                                <TableData className="price">
                                                                    <div
                                                                        style={{
                                                                            textDecoration:
                                                                                item.adjustedExtPrice &&
                                                                                'line-through',
                                                                            color:
                                                                                item.adjustedExtPrice &&
                                                                                '#E5047E',
                                                                        }}
                                                                    >
                                                                        {setCurrencyFormatWithoutSymbol(
                                                                            item.extPrice
                                                                        )}
                                                                    </div>
                                                                    {item.adjustedExtPrice && (
                                                                        <div>
                                                                            {setCurrencyFormatWithoutSymbol(
                                                                                item.adjustedExtPrice
                                                                            )}
                                                                        </div>
                                                                    )}
                                                                    {item.discount && (
                                                                        <div
                                                                            style={{
                                                                                whiteSpace:
                                                                                    'nowrap',
                                                                                marginLeft:
                                                                                    Math.abs(
                                                                                        item.discount
                                                                                    ).toString()
                                                                                        .length ==
                                                                                    1
                                                                                        ? '-27%'
                                                                                        : Math.abs(
                                                                                              item.discount
                                                                                          ).toString()
                                                                                              .length ==
                                                                                          2
                                                                                        ? '-31%'
                                                                                        : '-44%',
                                                                                color: '#E5047E',
                                                                            }}
                                                                        >
                                                                            {`${
                                                                                item.discount
                                                                            }${t(
                                                                                'equity.common.feesAndItems.discount'
                                                                            )}`}
                                                                        </div>
                                                                    )}
                                                                </TableData>
                                                            )}
                                                        {!isForProductGuide &&
                                                            !isForSetItem && (
                                                                <TableData
                                                                    className="delete"
                                                                    paddingDelete={
                                                                        isEquityPage
                                                                            ? 'none'
                                                                            : isItemBundlePopup
                                                                            ? '5%'
                                                                            : '5%'
                                                                    }
                                                                >
                                                                    <div
                                                                        className={
                                                                            item.isPlaceHolderAdded ||
                                                                            item.isDeleteButtonPresent ===
                                                                                false
                                                                                ? 'disabled'
                                                                                : ''
                                                                        }
                                                                        style={{
                                                                            width: '25px',
                                                                            height: '29px',
                                                                            display:
                                                                                'flex',
                                                                            justifyContent:
                                                                                'center',
                                                                            alignItems:
                                                                                'center',
                                                                            border: 'unset',
                                                                            boxShadow:
                                                                                '0px 0px 2px #00000029',
                                                                            borderRadius:
                                                                                '6px',
                                                                            opacity:
                                                                                '1',
                                                                            visibility:
                                                                                item.isDeleteButtonPresent ===
                                                                                false
                                                                                    ? 'hidden'
                                                                                    : '',
                                                                        }}
                                                                    >
                                                                        <img
                                                                            src={
                                                                                DeleteIcon
                                                                            }
                                                                            alt={
                                                                                'delete'
                                                                            }
                                                                            id = {`item-delete-icon-${item.productCFN || item.cfn || item.bom || index}`}
                                                                            onClick={() =>
                                                                                isSubItem
                                                                                    ? isEquityTemplate
                                                                                        ? deleteProduct(
                                                                                              item,
                                                                                              'Bundle',
                                                                                              productKeyBundle
                                                                                          )
                                                                                        : ((isEquityPage && isQuickOrder) || (isQuickOrder && isQuickOrderEquityTemplate)) ? deleteProduct (item, 'isBundle')
                                                                                        : deleteProduct(
                                                                                              productKeyBundle,
                                                                                              item.productKey
                                                                                          )
                                                                                    : isItemBundlePopup
                                                                                    ? deleteProduct(
                                                                                          item.productKey
                                                                                      )
                                                                                    : deleteProduct(
                                                                                          item
                                                                                      )
                                                                            }
                                                                            style={{
                                                                                cursor: 'pointer',
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </TableData>
                                                            )}
                                                    </>
                                                )
                                            )}
                                        </TableRow>
                                        {item.batchAllocationError &&
                                            isShippingScreen && (
                                                <tr
                                                    style={{
                                                        backgroundColor:
                                                            index % 2 === 0
                                                                ? 'white'
                                                                : '#f5f5f5cc',
                                                        borderBottom:
                                                            '1px solid #ddd',
                                                    }}
                                                >
                                                    <td
                                                        colSpan="5"
                                                        className="full-width"
                                                    >
                                                        <ProductErrorText
                                                            style={{
                                                                padding:
                                                                    '0 0 0 19px',
                                                                marginTop:
                                                                    '-13px',
                                                            }}
                                                        >
                                                            <AlertIcon
                                                                src={
                                                                    AlertCircleOutline
                                                                }
                                                                height="14px"
                                                                width="auto"
                                                            />
                                                            <div>
                                                                {t(
                                                                    'scheduleSurgery.Shipping.ProductCard.batchAllocationError'
                                                                )}
                                                            </div>
                                                        </ProductErrorText>
                                                    </td>
                                                </tr>
                                            )}
                                        {expandedItems[
                                            item.productKey || index
                                        ] &&
                                            (item?.children ||
                                                item?.bundleItems) && (
                                                <tr
                                                    style={{
                                                        borderBottom:
                                                            isOrderScreen &&
                                                            '1px solid #ddd',
                                                        background:
                                                            index % 2 === 0
                                                                ? 'white'
                                                                : '#f5f5f5cc',
                                                    }}
                                                >
                                                    <td
                                                        colSpan={
                                                            isTemplateDetail
                                                                ? '7'
                                                                : '9'
                                                        }
                                                        className="full-width"
                                                    >
                                                        <ListView
                                                            isReviewSubmitScreenEquity={
                                                                isReviewSubmitScreenEquity
                                                            }
                                                            productKeyBundle={
                                                                item.productKey
                                                            }
                                                            products={
                                                                item.children ||
                                                                item.bundleItems
                                                            }
                                                            setsQuantityCheck={
                                                                setsQuantityCheck
                                                            }
                                                            handleSetItemClick={
                                                                handleSetItemClick
                                                            }
                                                            addCount={addCount}
                                                            removeCount={
                                                                removeCount
                                                            }
                                                            deleteProduct={
                                                                deleteProduct
                                                            }
                                                            isCartScreen={
                                                                isCartScreen
                                                            }
                                                            isEquityPage={
                                                                isEquityPage
                                                            }
                                                            isCondensedView={
                                                                isCondensedView
                                                            }
                                                            isSubItem={true}
                                                            handleBundlePopup={
                                                                handleBundlePopup
                                                            }
                                                            handleBundleSetItemClick={
                                                                handleBundleSetItemClick
                                                            }
                                                            isShippingScreen={
                                                                isShippingScreen
                                                            }
                                                            isReviewSubmitScreen={
                                                                isReviewSubmitScreen
                                                            }
                                                            inventoryShipping={
                                                                inventoryShipping
                                                            }
                                                            isOrderScreen={
                                                                isOrderScreen
                                                            }
                                                            moreTemplates={
                                                                moreTemplates
                                                            }
                                                            isEquityTemplate={
                                                                isEquityTemplate
                                                            }
                                                            isFromTemplates={
                                                                isFromTemplates
                                                            }
                                                            isSurgery={
                                                                isSurgery
                                                            }
                                                            isTemplateScreen={
                                                                isTemplateScreen
                                                            }
                                                            isTemplateDetail={
                                                                isTemplateDetail
                                                            }
                                                            parentIndex={index}
                                                            handleCheckBoxSelection={
                                                                handleCheckBoxSelection
                                                            }
                                                            updateProductQuantity={
                                                                updateProductQuantity
                                                            }
                                                            isEquity={isEquity}
                                                            isQuickOrder={isQuickOrder}
                                                        />
                                                    </td>
                                                </tr>
                                            )}
                                        {(item &&
                                            item.materialType &&
                                            item.materialType ==
                                                ITEMSDETAILS[2]
                                                    .materialType[
                                                    'bundle'
                                        ]) &&
                                        !isTemplateDetail &&
                                            !isReviewSubmitScreenEquity &&
                                            !isOrderScreen &&
                                            expandedItems[
                                                item.productKey || index
                                            ] && (
                                                <tr
                                                    style={{
                                                        borderBottom:
                                                            '1px solid #ddd',
                                                        background:
                                                            index % 2 === 0
                                                                ? 'white'
                                                                : '#f5f5f5cc',
                                                    }}
                                                >
                                                    <td
                                                        colSpan="9"
                                                        className="full-width"
                                                    >
                                                        <Button
                                                        id={'common-listView-addItemsButton'}
                                                            show={true}
                                                            margin={'0 0 1% 4%'}
                                                            height={'31px'}
                                                            width={''}
                                                            // secondaryWhiteBorder={
                                                            //     true
                                                            // }
                                                            variant={ButtonStyles?.secondaryWhiteBorder}
                                                            border={
                                                                '1px solid #101fee'
                                                            }
                                                            disabled={
                                                                false
                                                                //     isFromEquity
                                                                //         ? disabledEmptyCart
                                                                //         : (disabledEmptyCart &&
                                                                //           disabledEmptyCart?.length > 0
                                                                //               ? !disabledEmptyCart?.filter(
                                                                //                     (item) =>
                                                                //                         products?.some(
                                                                //                             (data) =>
                                                                //                                 data.cfn !=
                                                                //                                 item.cfn
                                                                //                         )
                                                                //                 ).length > 0
                                                                //               : false) ||
                                                                //           products?.every(
                                                                //               (product) =>
                                                                //                   product.isDeleteButtonPresent ===
                                                                //                   false
                                                                //           )
                                                            }
                                                            clicked={() => {
                                                                try {
                                                                    handleBundlePopup(
                                                                        item
                                                                    );
                                                                    !isEquityTemplate &&
                                                                        handleBundleSetItemClick(
                                                                            item
                                                                        );
                                                                } catch (error) {
                                                                    logErrorToConsole(error);
                                                                }
                                                            }}
                                                        >
                                                            {t(
                                                                'equity.common.bundleItems.additems'
                                                            )}
                                                        </Button>
                                                    </td>
                                                </tr>
                                            )}
                                        {isCartScreen &&
                                        item?.businessRules &&
                                        item?.businessRules?.length > 0
                                            ? item?.businessRules.map(
                                                  (msg, index) => {
                                                      return (
                                                          <tr key={index}>
                                                              <td
                                                                  colSpan="5"
                                                                  className="full-width"
                                                              >
                                                                  <ProductErrorText
                                                                      style={{
                                                                          padding:
                                                                              '0 0 0 19px',
                                                                      }}
                                                                  >
                                                                      <AlertIcon
                                                                          src={
                                                                              warning
                                                                          }
                                                                          height="14px"
                                                                          width="auto"
                                                                      />
                                                                      <div
                                                                          style={{
                                                                              color: '#b56409',
                                                                          }}
                                                                      >
                                                                          {
                                                                              msg?.subType
                                                                          }
                                                                          {'-'}
                                                                          {
                                                                              msg.message
                                                                          }
                                                                      </div>
                                                                  </ProductErrorText>
                                                              </td>
                                                          </tr>
                                                      );
                                                  }
                                              )
                                            : null}
                                        {isShippingScreen &&
                                            isTransferSurgery() &&
                                            item.status &&
                                            (countryISOCode === 'JP'
                                                ? item.status !==
                                                  'Not Allocated'
                                                : true) && (
                                                <tr
                                                    style={{
                                                        backgroundColor:
                                                            index % 2 === 0
                                                                ? 'white'
                                                                : '#f5f5f5cc',
                                                        borderBottom:
                                                            '1px solid #ddd',
                                                    }}
                                                >
                                                    <td
                                                        colSpan="6"
                                                        className="full-width"
                                                        style={{
                                                            padding:
                                                                '0 0 0 9px',
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                marginTop:
                                                                    '-2px',
                                                            }}
                                                        >
                                                            <CheckBoxTransfer
                                                                item={item}
                                                                inventoryShipping={
                                                                    inventoryShipping
                                                                }
                                                                countryISOCode={
                                                                    countryISOCode
                                                                }
                                                                handleLocationChange={
                                                                    handleLocationChange
                                                                }
                                                                checked={
                                                                    !item.shippingRequirement
                                                                }
                                                                selectedLocation={
                                                                    selectedLocation
                                                                }
                                                                allocatedData={
                                                                    allocatedData
                                                                }
                                                                isShowCheckBox={
                                                                    false
                                                                }
                                                                isMessageDisplay={
                                                                    true
                                                                }
                                                                isShowLabelEmpty={
                                                                    false
                                                                }
                                                                isShowDropDown={
                                                                    false
                                                                }
                                                            />
                                                        </div>
                                                        {/*end transfer surgery check*/}
                                                    </td>
                                                </tr>
                                            )}
                                    </>
                                )
                        )}
                </tbody>
            </ItemTable>
        </>
    );

    const renderMobileView = () =>
        products?.map((item, index) => (
            <ProductContainer
                key={index}
                borderTop={
                    index === 0 &&
                    '1px solid var(--borders-lines-medium, #0000004D)'
                }
                borderBottom={
                    index === products.length - 1 &&
                    '1px solid var(--borders-lines-medium, #0000004D)'
                }
            >
                <ProductData>
                    <ProductCfn
                    id = {`item-cfn-${item.productCFN || item.cfn || item.bom || index}`}
                        onClick={() => {
                            try {
                                handleSetItemClick(item);
                            } catch (error) {
                                logErrorToConsole(error);
                            }
                        }}
                    >
                        {item.productCFN || item.cfn || item.bom}
                    </ProductCfn>
                    <Quantity>
                        {item.quantity} × <TypeText>{item.uom}</TypeText>
                    </Quantity>
                </ProductData>
                <Description>{item.description}</Description>
                {item.brand && (
                    <Brands>
                        {t(
                            'scheduleSurgery.surgery.notifications.itemListView.brand'
                        )}
                        :<BrandsName>{`\u00A0${item.brand}`}</BrandsName>
                    </Brands>
                )}
                {/* <div>
                    {productBomDetails.find(
                        (bomDetail) => bomDetail.prodcutCFN === item.productCFN
                    )?.billOfMaterialsHistory ? (
                        <div style={{ display: 'flex' }}>
                            <img
                                src={AlertCircleOutlinePink}
                                height="14px"
                                width="14px"
                                style={{
                                    // cursor: 'pointer',
                                    marginTop: '1.1px',
                                }}
                            />
                            <span
                                style={{
                                    color: '#e59b05',
                                    // cursor: 'pointer',
                                    fontSize: '13px',
                                    fontWeight: '600',
                                    marginLeft: '5px',
                                    marginTop: '-1.3px',
                                }}
                            >
                                BoM Change
                            </span>
                        </div>
                    ) : null}
                </div> */}
            </ProductContainer>
        ));

          // Detect iPhone SE landscape
    const isIphoneSELandscape =
        typeof window !== 'undefined' &&
        window.screen &&
        ((window.screen.width === 667 && window.screen.height === 375) ||
         (window.screen.width === 375 && window.screen.height === 667)) &&
        window.innerWidth > window.innerHeight;


    return (
        <>
            <ItemListViewWrapper
                id={isForSetItem && id}
                width={isOrderScreen && '100%'}
                padding={!isOrderScreen && '0 5% 6% 5%'}
                desktopPading={isSubItem && '0 0%'}
                marginBottom={marginBottom}
            >
               {(!isMobileView || isIphoneSELandscape)
                    ? renderDesktopView()
                    : renderMobileView()}
            </ItemListViewWrapper>
        </>
    );
};

export default ListView;
